<template>
  <div class="home">

    <gnetHeader v-if="showheader"></gnetHeader>

    <gnetTabBar
      v-bind:titoloapp="$store.getters.appname"
      v-bind:tabs="$store.state.tabs"
      v-bind:active_tab="$store.state.active_tab"
      v-on:click="changeTab($event)"
    >
    </gnetTabBar>
    <div v-if="true" style="width:100%; text-align:center;  padding: 5px;">
      <div class="slds-grid slds-wrap;">

        <div class="slds-col slds-size_4-of-12 slds-text-align--center" >
          <button class="slds-button" v-on:click="showdettaglianti=!showdettaglianti" v-bind:class="{'slds-button_brand': showdettaglianti,'slds-button_neutral': !showdettaglianti}">Dettaglianti</button>
        </div>
        <div class="slds-col slds-size_4-of-12 slds-text-align--center" >
          <button class="slds-button" v-on:click="showgrossisti=!showgrossisti" v-bind:class="{'slds-button_brand': showgrossisti,'slds-button_neutral': !showgrossisti}">Grossisti</button>
        </div>
        <div class="slds-col slds-size_4-of-12 slds-text-align--center" >
          <button class="slds-button" v-on:click="showaltro=!showaltro" v-bind:class="{'slds-button_brand': showaltro,'slds-button_neutral': !showaltro}">Altro</button>
        </div>

      </div>
    </div>
    <gnetSituazione v-bind:dettaglianti="showdettaglianti" v-bind:grossisti="showgrossisti" v-bind:altro="showaltro"></gnetSituazione>
  </div>
</template>

<script>
// @ is an alias to /src
// import numeral from 'numeral'
// import apiclient from '@/apiclient.js'
import gnetHeader from '../components/header.vue'
import gnetTabBar from '../components/tabbar.vue'
import gnetSituazione from '../components/situazione.vue'
import gnetMixLib from '@/mixin.js'

export default {
  name: 'Home',
  mixins: [gnetMixLib],
  components: {
    gnetHeader,
    gnetTabBar,
    gnetSituazione,
  },
  data: function() {
    return {
        showheader: true,
        showdettaglianti: true,
        showgrossisti: false,
        showaltro: false,
    };
  },
  created: function() {
  },
  mounted: function() {
  },
  methods: {
  }
}
</script>
<style scoped>
</style>

